import { atom } from "jotai";

export const aiBotUpgradeModalOpenAtom = atom(false);

export const facebookCapiUpgradeModalOpenAtom = atom(false);
